var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.faq.ueberschrift')))]),_c('FAQ')],1)}
var staticRenderFns = []

export { render, staticRenderFns }